<div class="content-wrapper" [class.side-bar-margin]="isSideBarLocked">
  <pl-navigation></pl-navigation>
  <router-outlet></router-outlet>
</div>
